/**
 * Slugs of the product-documentation articles the app links to directly.
 *
 * Articles live in the `articles` DB table — `content/articles/*.md` is only a
 * source mirror, so a slug typo is a silent 404 with no type error and no build
 * failure. Referencing these constants instead of inline strings at least makes
 * a rename a single edit, and `ARTICLE_SLUG_VALUES` lets a test assert every
 * slug the UI links to is actually published.
 */
export const ARTICLE_SLUGS = {
    HOW_PAYMENTS_WORK: "how-payments-work",
    WHAT_IS_THE_WIKI: "what-is-the-wiki",
    HOW_TO_USE_THE_WIKI: "how-to-use-the-wiki",
    WHAT_ARE_PLOT_THREADS: "what-are-plot-threads",
    HOW_TO_USE_PLOT_THREADS: "how-to-use-plot-threads",
    WHAT_ARE_READER_CROWNS: "what-are-reader-crowns",
    HOW_READER_LEVELS_AND_CROWNS_WORK: "how-reader-levels-and-crowns-work",
    HOW_CROWN_DISCOVERY_WORKS: "how-crown-discovery-works",
    HOW_FAN_CLUBS_WORK: "how-fan-clubs-work",
    HOW_TO_CREATE_A_DISCORD_INVITE_LINK:
        "how-to-create-a-discord-invite-link",
    MEET_ASSISTANT_FLARE: "meet-assistant-flare",
} as const;

export type ArticleSlug = (typeof ARTICLE_SLUGS)[keyof typeof ARTICLE_SLUGS];

export const CROWN_DISCOVERY_ARTICLE_SECTIONS = {
    MOST_CROWNED: "most-crowned-this-month",
    ASCENDING: "ascending",
    FRESH_FINDS: "fresh-finds",
} as const;

export type CrownDiscoveryArticleSection =
    (typeof CROWN_DISCOVERY_ARTICLE_SECTIONS)[keyof typeof CROWN_DISCOVERY_ARTICLE_SECTIONS];

export const ARTICLE_SLUG_VALUES: readonly ArticleSlug[] =
    Object.values(ARTICLE_SLUGS);

/** Canonical path for an article the app links to. */
export function articlePath(slug: ArticleSlug): string {
    return `/articles/${slug}`;
}

/** Link directly to one definition in the Crown discovery guide. */
export function crownDiscoveryArticlePath(
    section: CrownDiscoveryArticleSection,
): string {
    return `${articlePath(ARTICLE_SLUGS.HOW_CROWN_DISCOVERY_WORKS)}#${section}`;
}
